import { Button } from '@components/ui/Button'
import styles from './styles.module.scss'

type FiltersFooterProps = {
  onFilterApply: () => void
  onFilterClear: () => void
  isApplyFitActive?: boolean
  hasActiveFilterOptions: boolean
}

export default function FiltersFooter({
  onFilterApply: handleFilterApply,
  onFilterClear: handleFilterClear,
  isApplyFitActive = false,
  hasActiveFilterOptions
}: FiltersFooterProps) {
  return (
    <div className={styles.footer}>
      <Button variant="primary" fullWidth="always" onClick={handleFilterApply}>
        View products {isApplyFitActive && 'in my Fit'}
      </Button>
      <Button
        variant="primary_outline"
        fullWidth="always"
        onClick={handleFilterClear}
        disabled={!hasActiveFilterOptions}
      >
        Clear
      </Button>
    </div>
  )
}
